import { render, staticRenderFns } from "./cdcSummaryBranch.vue?vue&type=template&id=6420490a"
import script from "./cdcSummaryBranch.vue?vue&type=script&lang=js"
export * from "./cdcSummaryBranch.vue?vue&type=script&lang=js"
import style0 from "./cdcSummaryBranch.vue?vue&type=style&index=0&id=6420490a&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports